export var ACTION;
(function (ACTION) {
    ACTION["GO_BACK"] = "GO_BACK";
})(ACTION || (ACTION = {}));
// export type TestActionPayload = {}
